import { LinkedFileToObject } from './LinkedFileToObject';

export class LinkedFilesToObjectWithId {
    objectId: string;
    linkedFiles: LinkedFileToObject[];
}
